// mui
import { Stack, Divider, ButtonBase, Badge, IconButton } from '@mui/material';

// components
import { Logo } from '@/components/atoms/Logo/Logo';
import { Icon } from '@/components/atoms/Icon/Icon';
import {
  AccountInfo,
  AccountInfoProps,
} from '@/pwa/atoms/AccountInfo/AccountInfo';

interface NavBarProps {
  accountInfoProps: AccountInfoProps;
  onLogoClick?: () => void;
  onNotificationsClick?: () => void;
  unreadCount?: number;
}
/**
 * NavBar shows the Logo, notification bell, and the AccountInfo components.
 */
export const NavBar = ({
  accountInfoProps,
  onLogoClick,
  onNotificationsClick,
  unreadCount,
}: NavBarProps) => {
  return (
    <Stack
      direction='column'
      spacing={0}
      sx={{
        position: 'relative',
        zIndex: 2,
        backgroundColor: 'background.default',
      }}
    >
      <Stack
        direction='row'
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingX: 2,
          paddingY: 1,
        }}
      >
        <ButtonBase onClick={onLogoClick} disableRipple>
          <Logo size='md' variant='symbol' />
        </ButtonBase>
        <Stack
          direction='row'
          spacing={2}
          sx={{
            alignItems: 'center',
          }}
        >
          {onNotificationsClick && (
            <IconButton
              aria-label='notifications'
              onClick={onNotificationsClick}
              sx={{ width: 40, height: 40 }}
            >
              <Badge
                badgeContent={unreadCount}
                color='error'
                invisible={!unreadCount}
              >
                <Icon icon='bell' fontSize={20} />
              </Badge>
            </IconButton>
          )}
          <AccountInfo {...accountInfoProps} />
        </Stack>
      </Stack>
      <Divider />
    </Stack>
  );
};

NavBar.displayName = 'NavBar';
export default NavBar;
